import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { DprSummary } from '@shared/models/dpr';
import { SubprojectConfiguration } from '@shared/models/project-setup';

@Component({
  selector: 'app-report-summary',
  templateUrl: './report-summary.component.html',
  styleUrls: ['./report-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportSummaryComponent {
  @Input({ required: true }) subprojectConfiguration: SubprojectConfiguration;
  @Input({ required: true }) dprSummary: DprSummary;
}
